import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Open from '../components/OpeningHours';
import AuthSwitch from '../components/AuthSwitch'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2, 1, 2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: `640px`,
    }
  },
  toolbar: theme.mixins.toolbar,
}))

export default function Home() {
  const classes = useStyles();
  return (<div>
      <div className={classes.toolbar} />
      <div className={classes.root}>
      </div>
      <AuthSwitch redirectTo={'/'}>
        <Open />
      </AuthSwitch>
    </div>
  );
}
